import styled from "styled-components";

export const Passenger = styled.div`
  width: 100%;
  margin-bottom: 14px;

  label {
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: 0;
    color: #374151;
    font-size: 12px;
    font-weight: 600;
  }

  label span {
    color: #dc2626;
  }

  input,
  select {
    width: 100%;
    min-width: 0;
    height: 38px;
    box-sizing: border-box;
    padding: 8px 10px;
    border: 1px solid #d1d5db;
    border-radius: 5px;
    background: #fff;
    font-size: 13px;
  }

  .passenger-card-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    font-size: 14px;
  }

  .passenger-card-heading span {
    color: #64748b;
    font-size: 12px;
    font-weight: 600;
  }

  .passenger-fields-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px 12px;
    margin-bottom: 10px;
  }

  .passenger-contact-choice {
    display: flex !important;
    flex-direction: row !important;
    align-items: center;
    gap: 8px !important;
    margin: 8px 0;
    font-weight: 500 !important;
  }

  .passenger-contact-choice input {
    width: 15px;
    height: 15px;
    margin: 0;
  }

  .passenger-contact-preview {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 16px;
    color: #64748b;
    font-size: 12px;
    margin-bottom: 10px;
  }

  @media (max-width: 560px) {
    .passenger-fields-grid {
      grid-template-columns: 1fr;
      gap: 9px;
    }
  }
`;

export const Select = styled.select`
  width: 100%;
  height: 38px;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 5px;
  background: #fff;
  font-size: 13px;
`;

export const Nid = styled.div`
  width: 100%;
`;

export const UserContactWrapper = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
`;

export const FirstNameAndNid = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
`;